/**
 * Quick View: open modal, fetch product form, handle variant change and add to cart.
 */
(function () {
  const modalEl = document.getElementById('quick-view-modal')
  if (!modalEl) return

  const bodyEl = modalEl.querySelector('.quick-view-modal-body')
  let modalInstance = null

  function getModal () {
    if (typeof window.bootstrap === 'undefined') return null
    if (!modalInstance) modalInstance = new window.bootstrap.Modal(modalEl)
    return modalInstance
  }

  function openModal (productHandle) {
    bodyEl.innerHTML = '<div class="text-center py-5"><div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading</span></div></div>'
    getModal()?.show()

    const url = `/products/${productHandle}?view=quickview`
    fetch(url)
      .then(res => res.text())
      .then(html => {
        bodyEl.innerHTML = html
        initQuickViewForm(bodyEl)
      })
      .catch(() => {
        bodyEl.innerHTML = '<p class="text-danger">Unable to load product. <a href="/products/' + productHandle + '">View product</a></p>'
      })
  }

  function initQuickViewForm (container) {
    const form = container.querySelector('.product-quick-view-form')
    const scriptEl = container.querySelector('script[data-quick-view-product]')
    if (!form || !scriptEl) return

    let productData = null
    try {
      productData = JSON.parse(scriptEl.textContent)
    } catch (e) {
      return
    }

    const priceEl = container.querySelector('.product-quick-view-price')
    const btnEl = form.querySelector('.btn-atc')
    const idInput = form.querySelector('[name="id"]')
    const selects = form.querySelectorAll('.product-option-select')
    const mainImg = container.querySelector('[data-quick-view-main-img]')
    const thumbs = container.querySelectorAll('[data-quick-view-thumb]')
    const buyNowLinks = container.querySelectorAll('[data-quick-view-buy-now]')
    const productUrl = productData.url || (productData.handle ? '/products/' + productData.handle : '')

    function setMainImage (src, alt) {
      if (!mainImg) return
      mainImg.src = src
      if (alt != null) mainImg.setAttribute('alt', alt)
    }

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', function () {
        const src = this.getAttribute('data-src')
        const alt = this.getAttribute('data-alt')
        if (src) setMainImage(src, alt || '')
        thumbs.forEach(t => t.classList.remove('border-primary'))
        this.classList.add('border-primary')
      })
    })

    selects.forEach(select => {
      select.addEventListener('change', function () {
        const opts = []
        container.querySelectorAll('.product-option-select').forEach(s => opts.push(s.value))
        const variant = productData.variants.find(v => {
          return (v.option1 || '') === (opts[0] || '') &&
            (v.option2 || '') === (opts[1] || '') &&
            (v.option3 || '') === (opts[2] || '')
        })
        if (variant && idInput) {
          idInput.value = variant.id
          if (priceEl) {
            const fmtCurrency = (c) => typeof Shopify !== 'undefined' && Shopify.formatMoney ? Shopify.formatMoney(c) : '$' + (c / 100).toFixed(2)
            let html = ''
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              html = '<span class="product-price-compare text-muted me-3"><span class="visually-hidden">Regular price &nbsp;</span><s>' + fmtCurrency(variant.compare_at_price) + '</s></span><span class="product-price-final"><span class="visually-hidden">Sale price &nbsp;</span>' + fmtCurrency(variant.price) + '</span>'
            } else {
              html = '<span class="product-price-final">' + fmtCurrency(variant.price) + '</span>'
            }
            if (variant.available === false) {
              html += '<span class="price-badge-sold-out badge">Sold out</span>'
            }
            priceEl.innerHTML = html
          }
          if (btnEl) {
            btnEl.disabled = !variant.available
            const textEl = btnEl.querySelector('.btn-atc-text')
            const dataText = btnEl.getAttribute('data-text-add-to-cart')
            if (textEl) {
              const soldOutText = btnEl.getAttribute('data-text-sold-out')
              textEl.textContent = variant.available ? (dataText || 'Add to cart') : (soldOutText || 'Sold out')
            }
          }
          if (mainImg && variant.featured_image && variant.featured_image.src) {
            setMainImage(variant.featured_image.src, variant.featured_image.alt || '')
            thumbs.forEach(t => {
              const mid = t.getAttribute('data-media-id')
              t.classList.toggle('border-primary', String(variant.featured_image && variant.featured_image.id) === mid)
            })
          }
          if (buyNowLinks.length && productUrl) {
            const variantUrl = productUrl + (productUrl.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variant.id
            buyNowLinks.forEach(link => { link.href = variantUrl })
          }
        }
      })
    })
  }

  window.onChangeQuickViewVariant = function (selectEl, event) {
    const container = selectEl.closest('.product-quick-view-content')
    if (container) initQuickViewForm(container)
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-quick-view-handle]')
    if (!btn) return
    e.preventDefault()
    e.stopPropagation()
    const handle = btn.getAttribute('data-quick-view-handle')
    if (handle) openModal(handle)
  })
})()
